import axios from 'axios';
import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';
import * as Page from '../../lib/page';

function requestPopularQuestions() {
  return {
    type: types.REQUEST_POPULAR_LIST,
  };
}


function receivePopularQuestions(response, experience) {
  const articles = _get(response, 'recommendedSolutions');
  return {
    type: types.RECEIVE_POPULAR_LIST,
    payload: {
      experience,
      articles,
    },
  };
}
function receivePopularQuestionsError() {
  return {
    type: types.RECEIVE_POPULAR_ERROR,
  };
}

export default function getPopularQuestions(experience) {
  return (dispatch) => {
    dispatch(requestPopularQuestions());
    const recommendUrl = '/smarthelp/recommended-solutions';
    return axios.get(Page.setChannelForTechnicalExp(recommendUrl))
      .then(response => dispatch(receivePopularQuestions(response.data, experience)))
      .catch(() => {
        dispatch(receivePopularQuestionsError());
      });
  };
}
